module.exports = __webpack_public_path__ + "img/Icon_Halal_Active.834591c3.png";